import { Routes } from '@angular/router';
import { AuthSuccessfulComponent } from './common/auth/auth-successful/auth-successful';
import { authGuard } from './common/auth/guards/auth.guard';
import { noAuthGuard } from './common/auth/guards/no-auth.guard';
import { LandingComponent as Wizard2LandingComponent } from './features/wizard/v2/1-landing/landing';
import { StepAuthV2Component } from './features/wizard/v2/2-auth/step-auth';
import { StepProfileV2Component } from './features/wizard/v2/3-profile/step-profile';
import { StepSchoolV2Component } from './features/wizard/v2/4-school/step-school';
import { StepPersonalizeV2Component } from './features/wizard/v2/5-personalize/step-personalize';
import { DashboardComponent } from './features/dashboard/dashboard';
import { LoginComponent } from './features/login/login';

export const routes: Routes = [
  {
    path: '',
    component: Wizard2LandingComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'auth-successful',
    component: AuthSuccessfulComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },

  {
    path: 'wizard/v2/landing',
    component: Wizard2LandingComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'wizard/v2/auth',
    component: StepAuthV2Component,
  },
  {
    path: 'wizard/v2/profile',
    component: StepProfileV2Component,
    canActivate: [authGuard],
  },
  {
    path: 'wizard/v2/school',
    component: StepSchoolV2Component,
    canActivate: [authGuard],
  },
  {
    path: 'wizard/v2/personalize',
    component: StepPersonalizeV2Component,
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
